import $ from 'jquery';

// rAF Polyfill
// @see https://gist.github.com/paulirish/1579671
(function () {
  "use strict";

  var lastTime = 0,
      vendors = ['ms', 'moz', 'webkit', 'o'],
      x;

  for (x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
      window.cancelAnimationFrame  = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function (callback) {
          var currTime = new Date().getTime(),
              timeToCall = Math.max(0, 16 - (currTime - lastTime)),
              id = window.setTimeout(function () {
                  callback(currTime + timeToCall);
              }, timeToCall);
          lastTime = currTime + timeToCall;
          return id;
      };
  }

  if (!window.cancelAnimationFrame) {
      window.cancelAnimationFrame = function (id) {
          window.clearTimeout(id);
      };
  }
}());

var lastWindowPosition = 0;
var lastWindowWidth = $(window).width();
var lastWindowHeight = $(window).height();

var events = {
    "scroll": [],
    "resize": [],
    "resizeVertical": [],
};

triggerEvents();

function triggerEvents() {
    frame(triggerScroll);
    frame(triggerResize);
    frame(triggerResizeVertical);
}

function frame(fn) {
    requestAnimationFrame(temp);

    function temp() {
        fn();
        requestAnimationFrame(temp);
    }
}

function onEvent($event, callback) {
    events[$event].push(callback);
}

function triggerScroll() {
    if (window.pageYOffset !== lastWindowPosition) {
        events.scroll.forEach(function(e) {
            e(window.pageYOffset, getScrollDirection());
        });

        lastWindowPosition = window.pageYOffset;
    }
}

function triggerResize() {
    var currentWidth = $(window).width();

    if (currentWidth !== lastWindowWidth) {
        events.resize.forEach(function(e) {
            e(currentWidth);
        });

        lastWindowWidth = currentWidth;
    }
}

function triggerResizeVertical() {
    var currentHeight = $(window).height();

    if (currentHeight !== lastWindowHeight) {
        events.resizeVertical.forEach(function(e) {
            e(currentHeight);
        });

        lastWindowHeight = currentHeight;
    }
}

function getScrollDirection() {
    return window.pageYOffset < lastWindowPosition ? "up" : "down";
}

const PerformantEvents = {
    onEvent: onEvent,
}

export default PerformantEvents
